import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectUpdatedDocument = createSelector(
  [(store: RootState) => store.documentUpdate.document],
  (signStatus) => signStatus
);
